import { BusinessObjectBase } from './base';
import type { Role } from './role';
import type { User } from './user';

export interface RoleAssignmentData {
  readonly id: number;
  readonly userId: number;
  readonly user?: User;
  readonly roleId: number;
  readonly role?: Role;
}

export interface RoleAssignment extends Readonly<RoleAssignmentData> {}
export class RoleAssignment extends BusinessObjectBase {
  static readonly entityName = 'RoleAssignment' as const;
  static readonly plural = 'role-assignments';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<RoleAssignment[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new RoleAssignment(data));
  }

  static async findOne(filter?: any): Promise<RoleAssignment | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new RoleAssignment(data) : null;
  }

  static async findById(id: number, filter?: any): Promise<RoleAssignment> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new RoleAssignment(data);
  }

  static async create(
    data: Omit<RoleAssignmentData, 'id'>,
  ): Promise<RoleAssignment> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new RoleAssignment(result);
  }

  static async updateById(
    id: number,
    data: Partial<RoleAssignmentData>,
  ): Promise<RoleAssignment> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new RoleAssignment(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
